export const mutations = {
  setChats: (state, data) => (state.chats = data),
  updateNewChatMessages: (state, messages) => (state.newChatMessages = messages),
}
